import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FormlyFieldConfig } from "@ngx-formly/core";
import { simpleDeepClone } from '@phx-erp/shared';
import { I18nService } from '../../../../@core/services/i18n/i18n.service';

let cachedTextFallbackFields: FormlyFieldConfig[] | undefined;

export function addEditLineItemTextFallbackFields(_i18n: I18nService): FormlyFieldConfig[] {
    cachedTextFallbackFields ??= createAddEditLineItemTextFallbackFields();
    return simpleDeepClone(cachedTextFallbackFields);
}

function createAddEditLineItemTextFallbackFields(): FormlyFieldConfig[] {
    return [
        {
            type: 'tabBootstrap',
            fieldGroup: [
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.overview"),
                        icon: "fa fa-tachometer-alt",
                        translate: true
                    },
                    fieldGroup: [
                        {
                            className: "w-full",
                            fieldGroupClassName: 'flex flex-wrap',
                            props: {
                                label: _("document-line-item.add-edit-detail"),
                                translate: true
                            },
                            fieldGroup: [
                                {
                                    fieldGroupClassName: 'flex flex-wrap',
                                    className: "w-full",
                                    props: {

                                    },
                                    fieldGroup: [
                                        {
                                            key: 'description',
                                            className: "w-full md:w-1/2",
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.description'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-description-field"
                                                }
                                            },
                                        },
                                        {

                                            key: 'addition',
                                            className: "w-full md:w-1/2",
                                            type: 'input',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('document-line-item.addition'),
                                                translate: true,
                                                attributes: {
                                                    'data-testid': "formly-addition-field"
                                                }
                                            },

                                        },
                                        {
                                            key: 'productText',
                                            className: "w-full",
                                            type: 'textarea',
                                            wrappers: ['simple-title'],
                                            props: {
                                                label: _('common.text'),
                                                translate: true,
                                                rows: 7,
                                                persistSize: true,
                                                attributes: {
                                                    'data-testid': "formly-product-text-field"
                                                }
                                            },
                                        },
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    fieldGroupClassName: 'flex flex-wrap',
                    props: {
                        label: _("document-line-item.other"),
                        icon: "fa-solid fa-ellipsis",
                        translate: true
                    },
                    fieldGroup: [
                        {
                            fieldGroupClassName: 'flex flex-wrap',
                            className: "w-full",
                            props: {

                            },
                            fieldGroup: [
                                // {
                                //     key: 'frozenPositionText',
                                //     className: "w-full",
                                //     type: 'checkbox',
                                //     props: {
                                //         label: _('document-line-item.frozen-position-text'),
                                //         translate: true
                                //     }
                                // },
                                {
                                    key: 'internalNotes',
                                    className: "w-full",
                                    type: 'textarea',
                                    props: {
                                        label: _('document-line-item.internal-notes'),
                                        translate: true,
                                        rows: 8,
                                        persistSize: true
                                    }
                                }
                            ],
                        },
                    ],
                },
            ]
        }
    ]
}


